import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface AppState {
  // 主题设置
  theme: 'light' | 'dark';
  setTheme: (theme: 'light' | 'dark') => void;
  
  // 语言设置
  language: 'zh' | 'en';
  setLanguage: (language: 'zh' | 'en') => void;
  
  // 用户信息
  user: {
    id?: string;
    name?: string;
    email?: string;
  } | null;
  setUser: (user: AppState['user']) => void;
  
  // 全局加载状态
  loading: boolean;
  setLoading: (loading: boolean) => void;

  // 最近一次场景任务执行 id，后续查询执行过程/结果时复用
  scenarioTaskRequestId?: string;
  setScenarioTaskRequestId: (requestId?: string) => void;
}

export const useAppStore = create<AppState>()(
  devtools(
    (set) => ({
      // 初始状态
      theme: 'light',
      language: 'zh',
      user: null,
      loading: false,
      scenarioTaskRequestId: undefined,
      
      // Actions
      setTheme: (theme) => set({ theme }, false, 'setTheme'),
      setLanguage: (language) => set({ language }, false, 'setLanguage'),
      setUser: (user) => set({ user }, false, 'setUser'),
      setLoading: (loading) => set({ loading }, false, 'setLoading'),
      setScenarioTaskRequestId: (requestId) =>
        set({ scenarioTaskRequestId: requestId }, false, 'setScenarioTaskRequestId'),
    }),
    {
      name: 'app-store',
    }
  )
);
